import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore }      from '@/stores/authStore'

// ── PrivateRoute: redireciona para login se não autenticado ──
export default function PrivateRoute() {
  const { user, initialized, loading } = useAuthStore()

  if (!initialized || loading) {
    return (
      <div className="min-h-screen bg-dark-900 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 rounded-xl bg-gradient-brand animate-pulse" />
          <p className="text-dark-400 text-sm">Carregando...</p>
        </div>
      </div>
    )
  }

  return user ? <Outlet /> : <Navigate to="/login" replace />
}
